import { Badge } from "primereact/badge";
import React from "react";

const StatusBadge = ({ status }) => {
  return <Badge style={{ backgroundColor: status?.primary_color }} />;
};

export default StatusBadge;
